import React from "react";
import {
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  Stack,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import "./MobileHeaderComponent.scss";
import { MoreVert } from "@mui/icons-material";
import NewChatMobile from "../../assets/images/NewChatMobile.svg";
import HistoryMobile from "../../assets/images/HistoryMobile.svg";
import ChatAssistant from "../../assets/images/ChatAssistant.svg";
import Logout from "../../assets/images/Logout.svg";
import Logo from "../../assets/images/SynapseLogo.png";
import HelpMobile from "../../assets/images/HelpMobile.svg";
import HistoryDrawer from "../HistoryDrawer/HistoryDrawer";
import { getUserSessions } from "../../redux/slice/get-user-sessions";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { inputUpdate, resetMessages, newChatStateUpdate } from "../../redux/slice/snackbar";
import { getOktaLogoutUrl } from "../../redux/config";
import { clearClientAuth } from "../../utils/common";
import { useDisplayIdentity } from "../../hooks/useDisplayIdentity";
import {
  UserAvatarSkeleton,
  UserNameSkeleton,
} from "../../components/UserIdentitySkeleton/UserIdentitySkeleton";

function MobileHeaderComponent(props) {
  // const { setInput } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [tabValue, setTabVal] = React.useState("");
  const openMenu = Boolean(anchorEl);
  const [state, setState] = React.useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const [open, setOpen] = React.useState(false);
  const authUser = useSelector((state) => state.auth.user);
  const userEmail = authUser?.email || "";
  const token = "__cookie__";
  // const client = queryParams.get("client");
  const client = "UT";
  const userName = useSelector((state) => state.userName.userName);
  const {
    initials,
    fullName: displayFullName,
    isLoading: displayIdentityLoading,
  } = useDisplayIdentity();
  const toggleDrawerOpen = (event, value) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    handleClose();
    setTabVal(value);
    setState(true);
  };
  const toggleDrawerClose = () => {
    setState(false);
  };
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    toggleDrawer(false)();
    clearClientAuth();
    window.location.replace(getOktaLogoutUrl());
  };

  const handleRedirectNewChatOpen = () => {
    const userSessionPayload = {
      userEmail: userEmail,
      token: token,
      client,
      minRows: 0,
      maxRows: 10,
    };
    dispatch(getUserSessions(userSessionPayload));
    dispatch(inputUpdate(""));
    dispatch(resetMessages());
    dispatch(newChatStateUpdate(true));
    handleClose();
  };

  return (
    <React.Fragment>
      <AppBar className="mobile-header">
        <Toolbar className="mobile-header-toolbar" disableGutters>
          <MenuIcon
            sx={{ marginLeft: "10px" }}
            onClick={toggleDrawer(true)}
            className="sales-rep-copilot-hamburger"
          />
          <Typography className="mobile-header-heading">
            <div className="logo-holder">
              <img
                src={Logo}
                alt="logo"
                className="supply-chain-logo"
              />
            </div>

            <IconButton
              onClick={(event) => handleClick(event)}
              className="mobile-heading-more-icon"
            >
              <MoreVert />
            </IconButton>
            <Menu
              className="mobile-menu-parent"
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                className="mobile-menu-item"
                onClick={() => {
                  handleRedirectNewChatOpen();
                }}
              >
                <img src={NewChatMobile} alt="new-chat-mobile-icon" />
                &nbsp; New Session
              </MenuItem>
              <MenuItem
                className="mobile-menu-item"
                onClick={(e) => toggleDrawerOpen(e, "history")}
              >
                <img src={HistoryMobile} alt="history-icon" />
                &nbsp; View History
              </MenuItem>
              <MenuItem
                className="mobile-menu-item"
                onClick={(e) => toggleDrawerOpen(e, "help")}
              >
                <img src={HelpMobile} alt="info-icon" />
                &nbsp; Help
              </MenuItem>
            </Menu>
          </Typography>
        </Toolbar>
      </AppBar>
      <HistoryDrawer
        open={state}
        value={tabValue}
        toggleDrawerClose={toggleDrawerClose}
      />
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        className="supply-chain-hamburger-drawer"
      >
        <Stack
          direction="row"
          spacing={2}
          className="supply-chain-stack-with-avatar"
        >
          {displayIdentityLoading ? (
            <UserAvatarSkeleton size={32} />
          ) : (
            <Avatar
              sx={{
                bgcolor: "#E56800",
                color: "white",
                fontWeight: "700",
                fontSize: "14px",
                width: "32px",
                height: "32px",
              }}
            >
              {initials}
            </Avatar>
          )}
          {displayIdentityLoading ? (
            <UserNameSkeleton width={100} height={18} />
          ) : (
            displayFullName || userName
          )}
        </Stack>
        <Stack className="supply-chain-stack-with-tab-data">
          <Typography>
            <img src={ChatAssistant} alt="chat-assistant" />
            Chat Assistant
          </Typography>
        </Stack>
        <Typography
          className="logout-paragraph"
          onClick={handleLogout}
          sx={{ cursor: "pointer" }}
        >
          <img src={Logout} alt="chat-assistant" />
          Logout
        </Typography>
      </Drawer>
    </React.Fragment>
  );
}

export default MobileHeaderComponent;
